import React from "react";
import classNames from "classnames";
import TextTruncate from "components/TextTruncate";
import { isNotEmpty } from "utils/validate";
import { renderNumberValue } from "utils/string";
import { INPUT } from "shared/labels";
import * as styles from "../../../../styles.module.scss";
const CellModelOrRecipeParameterPreview = ({ parameter }) => {
    const { units, max, min, granularity } = { ...parameter.parameter };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames(styles.cell, styles.unit) },
            React.createElement(TextTruncate, { className: styles.readonlyUnit, text: units ?? "" })),
        React.createElement("div", { className: classNames(styles.cell, styles.range) },
            React.createElement("span", { className: styles["preview-value"] }, isNotEmpty(min) && isNotEmpty(max)
                ? `${renderNumberValue(min)} - ${renderNumberValue(max)}`
                : INPUT.UNDEFINED)),
        React.createElement("div", { className: classNames(styles.cell, styles.granularity) },
            React.createElement("span", { className: styles["preview-value"] }, renderNumberValue(granularity) || INPUT.UNDEFINED))));
};
export default CellModelOrRecipeParameterPreview;
